/**
 * Manage Order - Header Component Controller
 *
 * @version
 * 4.71.0 OAUI-693 Tidy and remove duplicated code
 * 4.63.0 DEVOPS-715 order-admin-ui: setup new repo without vertical slicing
 * 4.36.0 OAUI-518 Add order reports and exports
 * 4.36.0 OAUI-502 Edit order details
 * 4.35.0 OAUI-497 View order attachments
 * 4.35.0 OAUI-496 Add header and missing fields
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2022-2024 Build Centrix
 */
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { WdOrdersService } from '../../../../../services/orders/wd-orders.service';
import { Router } from '@angular/router';
import { WdManageOrdersService } from '../../../../../services/orders/manage/wd-manage-orders.service';
import { IOrderFormModel } from '../../../../../interfaces/orders/order-interfaces';

@Component({
  selector: 'app-orders-manage-header-component',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ManageHeaderComponent {
  /**
   * Constructor Initialization
   * @since 4.35.0
   */
  constructor(
    public wdManageOrdersService: WdManageOrdersService,
    public wdOrdersService: WdOrdersService,
    public router: Router,
  ) {}

  // Order String Inputs
  @Input() orderTitle?: string;
  @Input() orderSubtitle?: string;

  // Order
  @Input() order: IOrderFormModel;

  /**
   * Navigate to Model Viewer
   *
   * @since 4.63.0
   */
  navigateToModelViewer(element: any): void {
    void this.router.navigate(['modelViewer', 'view', element.details?.index]);
  }
}
